define('util/PromiseUtils',[
    'lib/bluebird'
], function (
    Promise
) {
    'use strict';

    return {
        /**
         * Creates a function that will ensure that the promise returned from the provided
         * function will be canceled when called subsequent times.
         *
         * ** NOTE **
         *
         * For this method to work properly, the returned function must have .cancellable()
         * called on the root promise at some point during its creation. If this does not
         * occur, the canceling of the pending promise on subsequent calls will not be
         * canceled properly and still execute. The best way to handle this would be to
         * call .cancellable() before any of your .then() declarations:
         *
         *      var promise = myPromiseFn()
         *                      .cancellable()
         *                      .then(function (resp) {
         *                          return Promise.all([myFn1, myFn2]);
         *                      })
         *                      .then(function (resp) {
         *                          return myPromiseFn3();
         *                      })
         *
         * Promises returned from apiCore.js are cancellable by default, but wrapping those
         * promise objects in new instances of a Promise (e.g. w/ Promise.all([])) will
         * result in promises that need to have their cancellable flag set.
         *
         *
         * @param {Function} func    A function that will return an instance of a Promise when
         *  executed.
         */
        cancelIfPending: function PromiseUtil$cancelIfPending (func) {
            var pendingPromise;

            return function () {
                if (pendingPromise) {
                    pendingPromise.cancel();
                }

                pendingPromise = func.apply(null, arguments);

                if (!(pendingPromise instanceof Promise)) {
                    throw new Error("cancelIfPending: The provided function needs to return an instance of a Promise object");
                }

                if (!pendingPromise.isCancellable()) {
                    throw new Error("cancelIfPending: The returned Promise has not been set as cancellable. You must call .cancellable() in the creation of your promise for cancelIfPending to work.");
                }

                return pendingPromise
                        .finally(function () {
                            pendingPromise = undefined;
                        });
            };
        }
    };
});
